/**
 *
 * PageLogo
 *
 */

import React from "react"
import "./index.less"

function PageLogo(props) {
  return (
    <div className="pageLogo">
      <div />
      {props.children}
    </div>
  )
}

PageLogo.propTypes = {}

export default PageLogo
